import {
  LIST_MCU_PROJECT_PERIOD_REQUEST,
  LIST_MCU_PROJECT_PERIOD_SUCCESS,
  LIST_MCU_PROJECT_PERIOD_FAIL,
  DETAIL_MCU_PROJECT_PERIOD_REQUEST,
  DETAIL_MCU_PROJECT_PERIOD_SUCCESS,
  DETAIL_MCU_PROJECT_PERIOD_FAIL,
  CREATE_MCU_PROJECT_PERIOD_REQUEST,
  CREATE_MCU_PROJECT_PERIOD_SUCCESS,
  CREATE_MCU_PROJECT_PERIOD_FAIL,
  UPDATE_MCU_PROJECT_PERIOD_REQUEST,
  UPDATE_MCU_PROJECT_PERIOD_SUCCESS,
  UPDATE_MCU_PROJECT_PERIOD_FAIL,
  UPDATE_MCU_PROJECT_PERIOD_STATUS_REQUEST,
  UPDATE_MCU_PROJECT_PERIOD_STATUS_SUCCESS,
  UPDATE_MCU_PROJECT_PERIOD_STATUS_FAIL,
  DELETE_MCU_PROJECT_PERIOD_REQUEST,
  DELETE_MCU_PROJECT_PERIOD_SUCCESS,
  DELETE_MCU_PROJECT_PERIOD_FAIL,
  RESET_MCU_PROJECT_PERIOD
} from '../../constants/mcu-project-period'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingCreate: false,
  loadingStatus: false,
  loadingDelete: false,
  selectedStatusId: null,
  selectedDeleteId: null,
  mcuProjectPeriods: [],
  mcuProjectPeriod: {},
  error: null,
  pageable: {
    page: 1,
    size: 10,
    hits: 0
  }
}

const mcuProjectPeriodReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_PERIOD_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MCU_PROJECT_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectPeriods: action.payload,
        pageable: action.pageable || state.pageable
      }
    case LIST_MCU_PROJECT_PERIOD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectPeriods: []
      }
    case DETAIL_MCU_PROJECT_PERIOD_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        mcuProjectPeriod: {}
      }
    case DETAIL_MCU_PROJECT_PERIOD_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        mcuProjectPeriod: action.payload
      }
    case DETAIL_MCU_PROJECT_PERIOD_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        mcuProjectPeriod: {}
      }
    case CREATE_MCU_PROJECT_PERIOD_REQUEST:
    case UPDATE_MCU_PROJECT_PERIOD_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_MCU_PROJECT_PERIOD_SUCCESS:
    case UPDATE_MCU_PROJECT_PERIOD_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_MCU_PROJECT_PERIOD_FAIL:
    case UPDATE_MCU_PROJECT_PERIOD_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case UPDATE_MCU_PROJECT_PERIOD_STATUS_REQUEST:
      return {
        ...state,
        loadingStatus: true,
        selectedStatusId: action?.meta?.periodId || null
      }
    case UPDATE_MCU_PROJECT_PERIOD_STATUS_SUCCESS:
      return {
        ...state,
        loadingStatus: false,
        selectedStatusId: null
      }
    case UPDATE_MCU_PROJECT_PERIOD_STATUS_FAIL:
      return {
        ...state,
        loadingStatus: false,
        selectedStatusId: null,
        error: action.payload
      }
    case DELETE_MCU_PROJECT_PERIOD_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        selectedDeleteId: action?.meta?.periodId || null
      }
    case DELETE_MCU_PROJECT_PERIOD_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        selectedDeleteId: null
      }
    case DELETE_MCU_PROJECT_PERIOD_FAIL:
      return {
        ...state,
        loadingDelete: false,
        selectedDeleteId: null,
        error: action.payload
      }
    case RESET_MCU_PROJECT_PERIOD:
      return {
        ...state,
        error: null
      }
    default:
      return state
  }
}

export default mcuProjectPeriodReducer
